import React, { useState } from 'react';
import MenuList from '../components/MenuList';

const Analytics = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return (
    <div className='flex flex-col h-screen'>
      <div className='flex items-center py-4 mx-auto w-[95%]'>
        <h1 className='text-2xl text-orange-600'>Analytics</h1>
      </div>
      <div className='flex-1 overflow-hidden mx-auto w-[95%]'>
        <iframe
          title='report'
          width='100%'
          height='100%'
          src='https://lookerstudio.google.com/embed/u/0/reporting/f303e3f4-8d05-46c4-9342-0a4345c9489e/page/p_t6on21kdrd'
          frameBorder='0'
          style={{ border: '0', margin: 'auto' }}
          allowFullScreen
          sandbox='allow-storage-access-by-user-activation allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox'
        ></iframe>
      </div>
    </div>
  );
};

export default Analytics;
